import TabsCore from '@studiometa/js-toolkit/components/Tabs';
import nextFrame from '@studiometa/js-toolkit/utils/nextFrame';

/**
 * Tabs.
 */
export default class Tabs extends TabsCore {
  optionsIsOpen = false;

  /**
   * Mounted.
   *
   * @return {void}
   */
  mounted() {
    super.mounted();
    this.updateSelected();
  }

  /**
   * onSelectBtnClick.
   *
   * @return {void}
   */
  onSelectBtnClick() {
    if (this.optionsIsOpen) {
      this.closeOptions();
    } else {
      this.openOptions();
    }
  }

  /**
   * onSelectBtnClick.
   *
   * @return {void}
   */
  onSelectOptionsClick() {
    this.closeOptions();
  }

  /**
   * Open options element.
   *
   * @return {void}
   */
  openOptions() {
    this.$refs.selectOptions.classList.add('is-open');
    this.optionsIsOpen = true;
  }

  /**
   * onBtnClick.
   *
   * @param {MouseEvent} e event.
   * @param {number} i index btn.
   *
   * @return {void}
   */
  onBtnClick(e, i) {
    super.onBtnClick(e, i);
    this.updateSelected();
  }

  /**
   * Close options element.
   *
   * @return {void}
   */
  closeOptions() {
    this.$refs.selectOptions.classList.remove('is-open');
    this.optionsIsOpen = false;
  }

  /**
   * Update the selected element.
   *
   * @return {void}
   */
  async updateSelected() {
    await nextFrame();
    await nextFrame();
    const currentTab = this.$refs.btn.find((t) => t.classList.contains('is-open'));

    if (!currentTab) {
      return;
    }

    this.$refs.selectBtn.textContent = currentTab.textContent;
  }
}
